import { GetUserDetails, GetUserType } from './config'
import { AddSchoolLog } from './api-requests/api-request'
import { AnalyticService } from '../lib/analytics/analyticService'
import { IUserDetails, IUserType } from '../interfaces/user.interface'

const TrackPageViewHubspot = (email: string) => {
  let _window: any = window
  let _hsq = (_window._hsq = _window._hsq || [])
  _hsq.push([
    'identify',
    {
      email: email,
    },
  ])
  _hsq.push(['trackPageView'])
}

const identifyMixpanelUser = (opts: {
  userId: string
  userType: IUserType
  userDetails: IUserDetails
}) => {
  console.log('Identifying user', opts.userId)
  AnalyticService.identifyUser({
    userId: opts.userId,
    userType: opts.userType,
    email: opts?.userDetails?.email,
    firstName: opts?.userDetails?.name || (opts?.userDetails as any)?.firstName,
    lastName: opts?.userDetails?.name
      ? ''
      : (opts?.userDetails as any)?.lastName,
  })
}

export const SendSchoolLog = (school_details: any, course_id?: string) => {
  // if (process.env.NODE_ENV === "development") {
  //   console.log("Development node");
  //   return;
  // }
  const user_type: any =
    typeof localStorage !== 'undefined' ? GetUserType() : ''
  const user_details: any =
    typeof localStorage !== 'undefined' ? GetUserDetails() : {}

  const user_id =
    user_details && user_details._id ? user_details._id : undefined
  AddSchoolLog(
    school_details ? school_details._id : null,
    user_id,
    user_type,
    course_id,
  )
    .then(data => {
      console.log('school log added', data)
    })
    .catch(err => {
      console.log('error adding school log', err)
    })

  const user_email = user_details ? user_details.email : ''
  TrackPageViewHubspot(user_email)
  identifyMixpanelUser({
    userId: user_details?._id,
    userType: user_type,
    userDetails: user_details,
  })
}
